import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, ErrorForm, InputForm } from '../../components'
import { useForm, Controller } from 'react-hook-form'
import { useYupValidation } from '../../hooks'
import { forgotPasswordSchema } from '../../yup'
import { IAuthEmail } from '../../interfaces'
import logo from '../../assets/images/logo.png'
import { errorHandler } from '../../services'
import { AuthService } from '../../services/index'
import { toast } from 'react-toastify'

export default function ForgotPassaword(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const navigate = useNavigate()
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthEmail>({
        resolver: useYupValidation(forgotPasswordSchema),
    })

    async function emailConfirmation(values: IAuthEmail): Promise<void> {
        setIsLoading(true)
        try {
            await AuthService.emailConfirmation(values)
            navigate('/recovery-code', { state: values.email })
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div id="forgotPass__form">
            <div className="forgotPass__backgound">
                <div className="forgotPass__content">
                    <div className="forgotPass__images">
                        <img src={logo} alt="Logo CNA construtora" className="forgotPass__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <div className="forgotPass__wrapper-title">
                        <h4>Solicite a recuperação de senha.</h4>
                        <h4>Coloque seu e-mail no campo.</h4>
                    </div>
                    <form className="forgotPass__inputs" onSubmit={handleSubmit(emailConfirmation)}>
                        <Controller
                            name="email"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm label="E-mail" placeholder="E-mail" name="email" value={value} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.email?.message} />
                        <div className="box-button-forgot">
                            <Button type={'button'} placeholder="Cancelar" onClick={() => navigate('/login')} />
                            <Button isLoading={isLoading} type={'submit'} placeholder="Enviar e-mail" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
